<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_1149_3416)">
            <path d="M8.91032 1.16125C9.56117 0.510374 10.6162 0.510379 11.2671 1.16125L18.9274 8.82157C19.5783 9.47243 19.5783 10.5275 18.9274 11.1783L11.2671 18.8387C10.6162 19.4895 9.56117 19.4895 8.91032 18.8387L1.25 11.1783C0.599114 10.5275 0.599129 9.47242 1.25 8.82157L8.91032 1.16125ZM2.42838 9.99996L10.0887 17.6603L17.749 9.99996L10.0887 2.33964L2.42838 9.99996Z" />
            <path d="M9.18451 13.5322V6.47249C9.18451 6.01226 9.55761 5.63916 10.0178 5.63916C10.4781 5.63916 10.8512 6.01226 10.8512 6.47249V13.5322C10.8512 13.9925 10.4781 14.3656 10.0178 14.3656C9.55761 14.3656 9.18451 13.9925 9.18451 13.5322Z" />
            <path d="M13.5482 9.16919C14.0084 9.16919 14.3815 9.54229 14.3815 10.0025C14.3815 10.4628 14.0084 10.8359 13.5482 10.8359H6.48842C6.02819 10.8359 5.65509 10.4628 5.65509 10.0025C5.65509 9.54229 6.02819 9.16919 6.48842 9.16919H13.5482Z" />
            <path d="M11.9246 6.91713C12.25 6.59172 12.7775 6.59178 13.103 6.91713C13.4284 7.24257 13.4284 7.77008 13.103 8.09552L8.11113 13.0874C7.78569 13.4128 7.25818 13.4128 6.93274 13.0874C6.60742 12.7619 6.60734 12.2344 6.93274 11.909L11.9246 6.91713Z" />
            <path d="M6.93274 6.91717C7.25817 6.59174 7.78568 6.59174 8.11112 6.91717L13.103 11.909C13.4284 12.2345 13.4284 12.762 13.103 13.0874C12.7775 13.4128 12.25 13.4128 11.9246 13.0874L6.93274 8.09556C6.6073 7.77012 6.6073 7.24261 6.93274 6.91717Z" />
        </g>
        <defs>
            <clipPath id="clip0_1149_3416">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
